import {
  addReadOnlyQuantityColumns,
  manageReadOnlyQuantityColumns,
} from "../hooks"

export const getInventoryQuantityAdjustmentConfig = ({
  products,
  vendors,
  quantityBalances,
}) => {
  const fields = [
    {
      label: "Item",
      key: "product_id",
      type: "select",
      selectOptions: products,
      validators: [
        { validate: "required" },
        {
          validate: "unique_case_insensitive",
          error: "Duplicate item name in import",
        },
      ],
      description:
        "Select the inventory item to update. Only standard products are supported at this time.",
    },
    {
      label: "Adjustment Type",
      key: "adjustment_type",
      type: "select",
      selectOptions: [
        {
          value: "inventory_received",
          label: "Receive inventory",
          alternateMatches: ["Receive inventory"],
        },
        {
          value: "inventory_returned",
          label: "Return inventory",
          alternateMatches: ["Return inventory"],
        },
      ],
      validators: [{ validate: "required" }],
    },
    {
      label: "Quantity",
      key: "quantity",
      type: ["number", { preset: "plain", min: 0, max: 999999.99999 }],
      validators: [{ validate: "required" }],
      description:
        "The quantity purchased or returned, to be entered as a positive number up to 1M, with up to 5 decimal places. Use the Adjustment Type column to record whether the quantity is received or returned.",
    },
    {
      label: "Purchase Price (Per Unit)",
      key: "purchase_price_per_unit",
      type: [
        "number",
        {
          preset: "plain",
          displayFormat: {
            thousandSeparated: true,
            output: "currency",
            currencySymbol: "$",
            currencyPosition: "prefix",
          },
          outputFormat: {
            thousandSeparated: false,
            output: "number",
          },
          min: 0,
        },
      ],
      description:
        "The amount paid to the vendor per unit (not the price you will sell it for).",
    },
    {
      label: "Vendor",
      key: "vendor",
      type: ["select", { allowCustom: true }],
      selectOptions: vendors,
      description: "Vendor name",
    },
    {
      label: "Reference #",
      key: "reference_number",
      type: "string",
      description: "Invoice/PO number",
    },
  ]

  const rowHooks = [manageReadOnlyQuantityColumns(quantityBalances)]
  const stepHooks = [
    {
      type: "REVIEW_STEP",
      callback: (instance, data) => addReadOnlyQuantityColumns(instance, data),
    },
  ]

  return { fields, rowHooks, stepHooks }
}
